import * as defaultImport from "@splunk/react-icons/SquaresLayered";
export * from "@splunk/react-icons/SquaresLayered";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
